// Commented code as a fallback
// in case it's needed to reactivate Swatch King temporarily

document.addEventListener("DOMContentLoaded", function () {
  // setTimeout(function () {
  //   const input = document.querySelector('body.showChipsSizes fieldset input[name="Color"]')
  //   if (input) {
  //     const fieldset = input.closest("fieldset")
  //     if (fieldset) {
  //       fieldset.style.display = "none"
  //     }
  //   }

  //   const sizeChartButton = document.getElementById("size-chart-button")
  //   const sizeVariants = document.querySelector('variant-swatch-king div[option-name="Size"]')
  //   const usSizeInfo = document.getElementById("us-size-info")

  //   if (sizeVariants) {
  //     let sizeChartSection = document.getElementById("size-chart-section")
  //     if (!sizeChartSection) {
  //       sizeChartSection = document.createElement("div")
  //       sizeChartSection.id = "size-chart-section"
  //     }

  //     if (usSizeInfo) sizeChartSection.appendChild(usSizeInfo)
  //     if (sizeChartButton) sizeChartSection.appendChild(sizeChartButton)

  //     sizeVariants.parentNode.insertBefore(sizeChartSection, sizeVariants)
  //   }

  // addSelectedColorInfo()
  // }, 1000)

  const variantSelector = document.querySelector('[name="id"]')
  if (variantSelector) {
    const selectedVariantId = variantSelector.value
    const initialVariant = window.meta.product.variants.find(v => v.id == selectedVariantId)

    if (initialVariant?.sku) {
      updateCurrentSKU(initialVariant.sku)
    }

    variantSelector.addEventListener("change", function (event) {
      const selectedVariantId = event.target.value
      const variant = window.meta.product.variants.find(v => v.id == selectedVariantId)

      fetch(`${window.location.pathname}?variant=${selectedVariantId}&section_id=works-best-with`)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, "text/html")
          const newSection = doc.querySelector("#works-best-with")

          const currentSection = document.querySelector("#works-best-with")
          if (newSection && currentSection) {
            currentSection.replaceWith(newSection)
            if (typeof initCarousel === "function") initCarousel()
          }
        })

      fetch(`${window.location.pathname}?variant=${selectedVariantId}&section_id=related-products`)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, "text/html")
          const newSection = doc.querySelector("#related-products")

          const currentSection = document.querySelector("#related-products")
          if (newSection && currentSection) {
            currentSection.replaceWith(newSection)
          }
        })

      if (variant?.sku) {
        updateCurrentSKU(variant.sku)
      }
      // addSelectedColorInfo()
    })
  }
})

function updateCurrentSKU(sku) {
  const skuElement = document.querySelector(".currentSKU span")
  if (skuElement) {
    skuElement.textContent = sku
  }
}

// function addSelectedColorInfo() {
//   const swatchOption = document.getElementById("swatch-option1")
//   if (!swatchOption) return

//   const swatchSelector = swatchOption.querySelector("li[aria-checked='true']")
//   if (!swatchSelector) return

//   const colorValue = swatchSelector.getAttribute("orig-value")
//   if (!colorValue) return

//   const existingP = swatchOption.parentNode.querySelector("p.selectedColor")
//   if (existingP) {
//     existingP.remove()
//   }

//   const p = document.createElement("p")
//   p.classList.add("selectedColor")
//   p.textContent = colorValue

//   swatchOption.parentNode.insertBefore(p, swatchOption)
// }
